import SupportHeader from '../SupportHeader';

export default function Footer() {
  return (
    <footer className="w-full flex flex-col items-center justify-center">
      <SupportHeader />
      <div className="w-full items-center p-3 bg-[#363636]">
        <div className="flex items-center justify-between md:max-w-7xl md:mx-auto py-6">
          <div className="flex items-center gap-4">
            <img src="/icon.png" alt="Pedágio Digital" className="w-[111px] h-[32px] md:w-[140px] md:h-[40px] lg:w-[170px] lg:h-[49px]" />
          </div>
          <div className="flex items-end justify-end gap-4 md:gap-8">
            <img src="/svg/logo-motiva.svg" alt="motiva" className="w-[80px] h-[15px]  lg:w-[100px] lg:h-[19px]" />
            <img src="/svg/logo-ecorodovias.svg" alt="ecorodovias" className="w-[90px] h-[20px]  lg:w-[110px] lg:h-[25px]" />
            <img src="/svg/logo-sem-parar.svg" alt="Sem Parar" className="w-[35px] h-[28px]  lg:w-[40px] lg:h-[32px]" />
          </div>
        </div>
      </div>
    </footer>
  );
} 